import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" }
const _hoisted_2 = { class: "flex items-center justify-between mb-6" }
const _hoisted_3 = { class: "text-2xl font-bold text-dashboard-text flex items-center gap-2" }
const _hoisted_4 = { class: "flex gap-2" }
const _hoisted_5 = ["disabled", "title"]
const _hoisted_6 = { class: "mb-6 bg-white border border-dashboard-border rounded-xl p-4 shadow-sm" }
const _hoisted_7 = { class: "relative" }
const _hoisted_8 = {
  key: 0,
  class: "flex items-center justify-center py-12 bg-white border border-dashboard-border rounded-xl"
}
const _hoisted_9 = {
  key: 1,
  class: "bg-white border border-dashboard-border rounded-xl shadow-sm overflow-hidden"
}
const _hoisted_10 = { class: "overflow-x-auto" }
const _hoisted_11 = { class: "w-full" }
const _hoisted_12 = { class: "py-4 px-6" }
const _hoisted_13 = { class: "flex items-center gap-3" }
const _hoisted_14 = { class: "w-10 h-10 bg-[#22282F]/10 rounded-full flex items-center justify-center flex-shrink-0" }
const _hoisted_15 = { class: "text-sm font-medium text-dashboard-text" }
const _hoisted_16 = { class: "text-xs text-dashboard-muted" }
const _hoisted_17 = { class: "py-4 px-6" }
const _hoisted_18 = {
  key: 0,
  class: "inline-flex items-center bg-gray-100 gap-1 px-2 py-1 rounded-full text-xs font-medium"
}
const _hoisted_19 = {
  key: 1,
  class: "text-xs text-dashboard-muted italic"
}
const _hoisted_20 = { class: "py-4 px-6" }
const _hoisted_21 = {
  key: 0,
  class: "text-sm text-dashboard-text"
}
const _hoisted_22 = {
  key: 1,
  class: "text-sm text-dashboard-text"
}
const _hoisted_23 = {
  key: 2,
  class: "text-xs text-dashboard-muted italic"
}
const _hoisted_24 = { class: "py-4 px-6 text-center" }
const _hoisted_25 = { class: "py-4 px-6 text-center" }
const _hoisted_26 = { class: "flex items-center justify-center gap-2" }
const _hoisted_27 = ["onClick", "disabled", "title"]
const _hoisted_28 = ["onClick", "disabled", "title"]
const _hoisted_29 = ["onClick", "disabled", "title"]
const _hoisted_30 = ["onClick", "disabled", "title"]
const _hoisted_31 = ["onClick"]
const _hoisted_32 = {
  key: 0,
  class: "border-t border-dashboard-border px-6 py-4 flex items-center justify-between"
}
const _hoisted_33 = { class: "text-sm text-dashboard-muted" }
const _hoisted_34 = { class: "flex gap-2" }
const _hoisted_35 = ["disabled"]
const _hoisted_36 = ["disabled"]
const _hoisted_37 = {
  key: 2,
  class: "bg-white border border-dashboard-border rounded-xl p-12 text-center"
}
const _hoisted_38 = { class: "bg-white rounded-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto" }
const _hoisted_39 = { class: "sticky top-0 bg-white border-b border-dashboard-border px-6 py-4 flex items-center justify-between" }
const _hoisted_40 = { class: "p-6 space-y-4" }
const _hoisted_41 = { class: "flex items-center gap-4 pb-4 border-b border-dashboard-border" }
const _hoisted_42 = { class: "w-16 h-16 bg-[#22282F]/10 rounded-full flex items-center justify-center" }
const _hoisted_43 = { class: "text-xl font-bold text-dashboard-text" }
const _hoisted_44 = { class: "text-sm text-dashboard-muted" }
const _hoisted_45 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_46 = { class: "text-sm text-dashboard-text" }
const _hoisted_47 = { class: "text-sm" }
const _hoisted_48 = { class: "text-sm text-dashboard-text" }
const _hoisted_49 = { class: "text-sm text-dashboard-text" }
const _hoisted_50 = { class: "text-sm text-dashboard-text" }
const _hoisted_51 = { class: "text-sm text-dashboard-text" }
const _hoisted_52 = { class: "text-sm text-dashboard-text" }
const _hoisted_53 = { class: "text-sm text-dashboard-text" }
const _hoisted_54 = { class: "text-sm" }
const _hoisted_55 = {
  key: 0,
  class: "pt-4 border-t border-dashboard-border"
}
const _hoisted_56 = { class: "flex items-center justify-between" }
const _hoisted_57 = ["disabled"]

import { ref, computed, onMounted } from 'vue'
import { Users, User, UserX, UserPlus, Shield, Search, RefreshCw, Edit3, Eye, X, Mail, ShieldOff } from 'lucide-vue-next'
import AdminLayout from '@/layouts/AdminLayout.vue'
import UserFormModal from '@/components/UserFormModal.vue'
import { apiFetch } from '@/utils/apiFetch'
import { useToast } from '@/utils/toast'
import { useAuthStore } from '@/store/auth'

const perPage = 10

// Modal state

export default /*@__PURE__*/_defineComponent({
  __name: 'UsersView',
  setup(__props) {

const toast = useToast()
const authStore = useAuthStore()

// Permissions d'écriture (profil restreint = boutons désactivés).
const canCreateUser = computed(() => authStore.canAction('users.create'))
const canEditUser = computed(() => authStore.canAction('users.edit'))
const canResendActivation = computed(() => authStore.canAction('users.resend_activation'))
const canToggleActive = computed(() => authStore.canAction('users.toggle_active'))
const canReset2FA = computed(() => authStore.canAction('users.reset_2fa'))

const users = ref<any[]>([])
const loading = ref(false)
const searchQuery = ref('')
const selectedUser = ref<any>(null)
const currentPage = ref(1)
const showModal = ref(false)
const editingUserId = ref<number | null>(null)

// Renvoi d'email d'activation en cours (id de l'utilisateur ciblé)
const resendingId = ref<number | null>(null)
const resetting2FAId = ref<number | null>(null)

const filteredUsers = computed(() => {
  if (!searchQuery.value) return users.value
  const query = searchQuery.value.toLowerCase()
  return users.value.filter(user => 
    user.full_name.toLowerCase().includes(query) ||
    user.email.toLowerCase().includes(query) ||
    user.username.toLowerCase().includes(query) ||
    user.role?.nom?.toLowerCase().includes(query)
  )
})

const paginatedUsers = computed(() => {
  const start = (currentPage.value - 1) * perPage
  const end = start + perPage
  return filteredUsers.value.slice(start, end)
})

const totalPages = computed(() => Math.ceil(filteredUsers.value.length / perPage))

const fetchUsers = async () => {
  loading.value = true
  try {
    users.value = await apiFetch('/api/admin/users/')
  } catch (error: any) {
    toast.error('Erreur de chargement', error.message || 'Impossible de charger les utilisateurs')
  } finally {
    loading.value = false
  }
}

const refreshUsers = () => {
  currentPage.value = 1
  fetchUsers()
}

const selectUser = (user: any) => {
  selectedUser.value = user
}

const openCreateModal = () => {
  editingUserId.value = null
  showModal.value = true
}

const openEditModal = (userId: number) => {
  editingUserId.value = userId
  showModal.value = true
}

const closeModal = () => {
  showModal.value = false
  editingUserId.value = null
}

const handleModalSuccess = () => {
  fetchUsers()
}

const toggleUserActive = async (userId: number, currentStatus: boolean) => {
  try {
    await apiFetch(`/api/admin/users/${userId}/toggle-active/`, {
      method: 'POST',
      body: JSON.stringify({})
    })
    
    toast.success(
      'Statut modifié',
      `L'utilisateur a été ${currentStatus ? 'désactivé' : 'activé'} avec succès`
    )
    fetchUsers()
  } catch (error: any) {
    toast.error('Erreur', error.message || 'Impossible de modifier le statut')
  }
}

const resendActivation = async (user: any) => {
  if (resendingId.value) return
  const ok = window.confirm(
    `Renvoyer le mail de bienvenue à ${user.full_name || user.username} (${user.email}) ?\n\n` +
    `Un lien d'activation lui permettra de définir son mot de passe.`
  )
  if (!ok) return

  resendingId.value = user.id
  try {
    // Endpoint d'administration : authentifié et soumis à la permission
    // `users.resend_activation`, contrôlée par le serveur.
    //
    // Auparavant ce bouton appelait /api/auth/request-reset/, un endpoint
    // PUBLIC : la permission ne faisait alors que griser le bouton, et
    // n'importe qui pouvait déclencher l'envoi sans même être connecté.
    // Cacher un bouton ne protège rien — la barrière doit être côté serveur.
    await apiFetch(`/api/admin/users/${user.id}/resend-activation/`, {
      method: 'POST',
    })
    toast.success('Email envoyé', `Un lien a été envoyé à ${user.email}`)
  } catch (error: any) {
    toast.error('Erreur', error.message || "Impossible d'envoyer l'email")
  } finally {
    resendingId.value = null
  }
}

const getRoleBadgeClass = (code: string) => {
  const classes: Record<string, string> = {
    'ADMIN': 'bg-red-50 text-red-700',
    'SG': 'bg-purple-50 text-purple-700',
    'SGA': 'bg-indigo-50 text-indigo-700',
    'DIRECTEUR': 'bg-blue-50 text-blue-700',
    'CHEF_DEPT': 'bg-cyan-50 text-cyan-700',
    'CHEF_SERVICE': 'bg-teal-50 text-teal-700',
    'AGENT': 'bg-gray-50 text-gray-700',
    'SECRETARIAT': 'bg-pink-50 text-pink-700',
  }
  return classes[code] || 'bg-gray-50 text-gray-700'
}

const reset2FA = async (user: any) => {
  const ok = window.confirm(
    `Réinitialiser la double authentification de ${user.full_name || user.username} ?\n\n` +
    `L'utilisateur devra reconfigurer son application d'authentification à sa prochaine connexion.`
  )
  if (!ok) return

  resetting2FAId.value = user.id
  try {
    await apiFetch(`/api/admin/users/${user.id}/reset-2fa/`, { method: 'POST' })
    toast.success('2FA réinitialisée', `La double authentification de ${user.full_name || user.username} a été réinitialisée.`)
    if (selectedUser.value?.id === user.id) {
      selectedUser.value = { ...selectedUser.value, two_factor_enabled: false }
    }
    fetchUsers()
  } catch (error: any) {
    toast.error('Erreur', error.message || 'Impossible de réinitialiser la 2FA')
  } finally {
    resetting2FAId.value = null
  }
}

onMounted(() => {
  fetchUsers()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h2", _hoisted_3, [
            _createVNode(_unref(Users), { class: "w-6 h-6" }),
            _cache[6] || (_cache[6] = _createTextVNode(" Gestion des Utilisateurs "))
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              onClick: openCreateModal,
              disabled: !canCreateUser.value,
              title: canCreateUser.value ? '' : 'Action non autorisée pour votre profil',
              class: "px-4 py-2 bg-[#22282F] text-white rounded-lg hover:bg-[#22282F] transition-colors flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
            }, [
              _createVNode(_unref(UserPlus), { class: "w-4 h-4" }),
              _cache[7] || (_cache[7] = _createTextVNode(" Nouvel utilisateur "))
            ], 8, _hoisted_5),
            _createElementVNode("button", {
              onClick: refreshUsers,
              class: "px-4 py-2 text-[#22282F] bg-white rounded-lg hover:bg-gray-100 border border-[#22282F] transition-colors flex items-center gap-2"
            }, [
              _createVNode(_unref(RefreshCw), {
                class: _normalizeClass([{'animate-spin': loading.value}, "w-4 h-4"])
              }, null, 8, ["class"]),
              _cache[8] || (_cache[8] = _createTextVNode(" Actualiser "))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_unref(Search), { class: "absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-dashboard-muted" }),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
              type: "text",
              placeholder: "Rechercher un utilisateur par nom, email ou rôle...",
              class: "w-full pl-12 pr-4 py-3 bg-dashboard-bg border border-dashboard-border rounded-lg text-sm text-dashboard-text placeholder:text-dashboard-muted focus:outline-none focus:border-[#22282F] focus:ring-2 focus:ring-[#22282F]/20 transition-all"
            }, null, 512), [
              [_vModelText, searchQuery.value]
            ])
          ])
        ]),
        (loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _cache[9] || (_cache[9] = [
              _createElementVNode("div", { class: "w-8 h-8 border-4 border-[#22282F]/30 border-t-[#22282F] rounded-full animate-spin" }, null, -1)
            ])))
          : (filteredUsers.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("table", _hoisted_11, [
                    _cache[12] || (_cache[12] = _createElementVNode("thead", { class: "bg-dashboard-bg" }, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", { class: "text-left py-4 px-6 text-sm font-semibold text-dashboard-text" }, "Utilisateur"),
                        _createElementVNode("th", { class: "text-left py-4 px-6 text-sm font-semibold text-dashboard-text" }, "Rôle"),
                        _createElementVNode("th", { class: "text-left py-4 px-6 text-sm font-semibold text-dashboard-text" }, "Direction"),
                        _createElementVNode("th", { class: "text-center py-4 px-6 text-sm font-semibold text-dashboard-text" }, "Statut"),
                        _createElementVNode("th", { class: "text-center py-4 px-6 text-sm font-semibold text-dashboard-text" }, "Actions")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedUsers.value, (user) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: user.id,
                          class: "border-t border-dashboard-border hover:bg-dashboard-bg transition-colors"
                        }, [
                          _createElementVNode("td", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, [
                              _createElementVNode("div", _hoisted_14, [
                                _createVNode(_unref(User), { class: "w-5 h-5 text-[#22282F]" })
                              ]),
                              _createElementVNode("div", null, [
                                _createElementVNode("p", _hoisted_15, _toDisplayString(user.full_name), 1),
                                _createElementVNode("p", _hoisted_16, _toDisplayString(user.email), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_17, [
                            (user.role)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                                  _createVNode(_unref(Shield), { class: "w-3 h-3" }),
                                  _createTextVNode(" " + _toDisplayString(user.role.nom), 1)
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_19, "Aucun rôle"))
                          ]),
                          _createElementVNode("td", _hoisted_20, [
                            (user.direction)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(user.direction.code), 1))
                              : (user.ambassade)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(user.ambassade.code), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_23, "-"))
                          ]),
                          _createElementVNode("td", _hoisted_24, [
                            _createElementVNode("span", {
                              class: _normalizeClass([user.is_active ? 'bg-green-50 text-green-700' : 'bg-red-50 text-red-700', "inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium"])
                            }, [
                              _createElementVNode("div", {
                                class: _normalizeClass([user.is_active ? 'bg-green-500' : 'bg-red-500', "w-1.5 h-1.5 rounded-full"])
                              }, null, 2),
                              _createTextVNode(" " + _toDisplayString(user.is_active ? 'Actif' : 'Inactif'), 1)
                            ], 2)
                          ]),
                          _createElementVNode("td", _hoisted_25, [
                            _createElementVNode("div", _hoisted_26, [
                              _createElementVNode("button", {
                                onClick: ($event: any) => (openEditModal(user.id)),
                                disabled: !canEditUser.value,
                                title: canEditUser.value ? 'Modifier' : 'Modification non autorisée pour votre profil',
                                class: "inline-flex items-center gap-1 px-3 py-1 text-[#22282F] border border-[#22282F]/10 rounded-lg text-xs font-medium hover:bg-[#22282F]/10 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                              }, [
                                _createVNode(_unref(Edit3), { class: "w-3 h-3" }),
                                _cache[10] || (_cache[10] = _createTextVNode(" Modifier "))
                              ], 8, _hoisted_27),
                              _createElementVNode("button", {
                                onClick: ($event: any) => (resendActivation(user)),
                                disabled: resendingId.value === user.id || !canResendActivation.value || !user.email,
                                class: "inline-flex items-center gap-1 px-3 py-1 text-[#22282F] border border-[#22282F]/10 rounded-lg text-xs font-medium hover:bg-[#22282F]/10 transition-all disabled:opacity-50 disabled:cursor-not-allowed",
                                title: !canResendActivation.value ? 'Action non autorisée pour votre profil' : (!user.email ? 'Ce compte n\'a pas d\'adresse email' : 'Renvoyer le mail de bienvenue (lien de définition du mot de passe)')
                              }, [
                                _createVNode(_unref(Mail), {
                                  class: _normalizeClass([{'animate-pulse': resendingId.value === user.id}, "w-3 h-3"])
                                }, null, 8, ["class"]),
                                _cache[11] || (_cache[11] = _createTextVNode(" Renvoyer l'email "))
                              ], 8, _hoisted_28),
                              _createElementVNode("button", {
                                onClick: ($event: any) => (toggleUserActive(user.id, user.is_active)),
                                disabled: !canToggleActive.value,
                                class: _normalizeClass([user.is_active ? 'bg-[#22282F] text-white border-[#22282F] hover:bg-orange-100' : 'bg-green-50 text-white border-green-200 hover:bg-green-100', "hidden items-center gap-1 px-3 py-1 border rounded-lg text-xs font-medium transition-all disabled:opacity-50 disabled:cursor-not-allowed"]),
                                title: user.is_active ? 'Désactiver' : 'Activer'
                              }, _toDisplayString(user.is_active ? 'Désactiver' : 'Activer'), 11, _hoisted_29),
                              _createElementVNode("button", {
                                onClick: ($event: any) => (reset2FA(user)),
                                disabled: resetting2FAId.value === user.id || !canReset2FA.value,
                                class: "inline-flex items-center gap-1 px-3 py-1 bg-red-50 text-red-700 border border-red-200 rounded-lg text-xs font-medium hover:bg-red-100 transition-all disabled:opacity-50 disabled:cursor-not-allowed",
                                title: canReset2FA.value ? 'Réinitialiser la double authentification (2FA) de cet utilisateur' : 'Action non autorisée pour votre profil'
                              }, [
                                _createVNode(_unref(ShieldOff), {
                                  class: _normalizeClass([{'animate-pulse': resetting2FAId.value === user.id}, "w-3 h-3"])
                                }, null, 8, ["class"]),
                                _createTextVNode(" " + _toDisplayString(resetting2FAId.value === user.id ? 'En cours…' : 'Réinit. 2FA'), 1)
                              ], 8, _hoisted_30),
                              _createElementVNode("button", {
                                onClick: ($event: any) => (selectUser(user)),
                                class: "inline-flex items-center gap-1 px-3 py-1 bg-dashboard-bg border border-dashboard-border rounded-lg text-xs font-medium text-dashboard-text hover:bg-[#22282F] hover:text-white hover:border-[#22282F] transition-all",
                                title: "Voir détails"
                              }, [
                                _createVNode(_unref(Eye), { class: "w-3 h-3" })
                              ], 8, _hoisted_31)
                            ])
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ]),
                (totalPages.value > 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                      _createElementVNode("p", _hoisted_33, " Page " + _toDisplayString(currentPage.value) + " sur " + _toDisplayString(totalPages.value) + " (" + _toDisplayString(filteredUsers.value.length) + " utilisateurs) ", 1),
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("button", {
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (currentPage.value--)),
                          disabled: currentPage.value === 1,
                          class: "px-3 py-1 bg-dashboard-bg border border-dashboard-border rounded-lg text-sm font-medium text-dashboard-text hover:bg-[#22282F] hover:text-white hover:border-[#22282F] transition-all disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-dashboard-bg disabled:hover:text-dashboard-text disabled:hover:border-dashboard-border"
                        }, " Précédent ", 8, _hoisted_35),
                        _createElementVNode("button", {
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (currentPage.value++)),
                          disabled: currentPage.value === totalPages.value,
                          class: "px-3 py-1 bg-dashboard-bg border border-dashboard-border rounded-lg text-sm font-medium text-dashboard-text hover:bg-[#22282F] hover:text-white hover:border-[#22282F] transition-all disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-dashboard-bg disabled:hover:text-dashboard-text disabled:hover:border-dashboard-border"
                        }, " Suivant ", 8, _hoisted_36)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_37, [
                _createVNode(_unref(UserX), { class: "w-16 h-16 text-dashboard-muted mx-auto mb-4" }),
                _cache[13] || (_cache[13] = _createElementVNode("h3", { class: "text-lg font-semibold text-dashboard-text mb-2" }, "Aucun utilisateur trouvé", -1)),
                _cache[14] || (_cache[14] = _createElementVNode("p", { class: "text-sm text-dashboard-muted" }, "Essayez de modifier votre recherche", -1))
              ])),
        (selectedUser.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 3,
              class: "fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50",
              onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (selectedUser.value = null), ["self"]))
            }, [
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _cache[15] || (_cache[15] = _createElementVNode("h3", { class: "text-lg font-bold text-dashboard-text" }, "Détails de l'utilisateur", -1)),
                  _createElementVNode("button", {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (selectedUser.value = null)),
                    class: "p-2 hover:bg-dashboard-bg rounded-lg transition-colors"
                  }, [
                    _createVNode(_unref(X), { class: "w-5 h-5" })
                  ])
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("div", _hoisted_42, [
                      _createVNode(_unref(User), { class: "w-8 h-8 text-[#22282F]" })
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("h4", _hoisted_43, _toDisplayString(selectedUser.value.full_name), 1),
                      _createElementVNode("p", _hoisted_44, _toDisplayString(selectedUser.value.email), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("div", null, [
                      _cache[16] || (_cache[16] = _createElementVNode("label", { class: "text-xs font-medium text-dashboard-muted" }, "Username", -1)),
                      _createElementVNode("p", _hoisted_46, _toDisplayString(selectedUser.value.username), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _cache[17] || (_cache[17] = _createElementVNode("label", { class: "text-xs font-medium text-dashboard-muted" }, "Statut", -1)),
                      _createElementVNode("p", _hoisted_47, [
                        _createElementVNode("span", {
                          class: _normalizeClass([selectedUser.value.is_active ? 'bg-green-50 text-green-700' : 'bg-red-50 text-red-700', "inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium"])
                        }, _toDisplayString(selectedUser.value.is_active ? 'Actif' : 'Inactif'), 3)
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _cache[18] || (_cache[18] = _createElementVNode("label", { class: "text-xs font-medium text-dashboard-muted" }, "Rôle", -1)),
                      _createElementVNode("p", _hoisted_48, _toDisplayString(selectedUser.value?.role?.nom || '-'), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _cache[19] || (_cache[19] = _createElementVNode("label", { class: "text-xs font-medium text-dashboard-muted" }, "Direction", -1)),
                      _createElementVNode("p", _hoisted_49, _toDisplayString(selectedUser.value?.direction?.nom || selectedUser.value?.ambassade?.nom || '-'), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _cache[20] || (_cache[20] = _createElementVNode("label", { class: "text-xs font-medium text-dashboard-muted" }, "Département", -1)),
                      _createElementVNode("p", _hoisted_50, _toDisplayString(selectedUser.value?.departement?.nom || '-'), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _cache[21] || (_cache[21] = _createElementVNode("label", { class: "text-xs font-medium text-dashboard-muted" }, "Service", -1)),
                      _createElementVNode("p", _hoisted_51, _toDisplayString(selectedUser.value?.service?.nom || '-'), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _cache[22] || (_cache[22] = _createElementVNode("label", { class: "text-xs font-medium text-dashboard-muted" }, "Matricule", -1)),
                      _createElementVNode("p", _hoisted_52, _toDisplayString(selectedUser.value.matricule || '-'), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _cache[23] || (_cache[23] = _createElementVNode("label", { class: "text-xs font-medium text-dashboard-muted" }, "Téléphone", -1)),
                      _createElementVNode("p", _hoisted_53, _toDisplayString(selectedUser.value.telephone || '-'), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _cache[24] || (_cache[24] = _createElementVNode("label", { class: "text-xs font-medium text-dashboard-muted" }, "Double authentification", -1)),
                      _createElementVNode("p", _hoisted_54, [
                        _createElementVNode("span", {
                          class: _normalizeClass([selectedUser.value.two_factor_enabled ? 'bg-green-50 text-green-700' : 'bg-amber-50 text-amber-700', "inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium"])
                        }, _toDisplayString(selectedUser.value.two_factor_enabled ? 'Activée' : 'Non configurée'), 3)
                      ])
                    ])
                  ]),
                  (selectedUser.value.two_factor_enabled)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                        _createElementVNode("div", _hoisted_56, [
                          _cache[25] || (_cache[25] = _createElementVNode("div", null, [
                            _createElementVNode("p", { class: "text-sm font-medium text-dashboard-text" }, "Réinitialiser la 2FA"),
                            _createElementVNode("p", { class: "text-xs text-dashboard-muted mt-0.5" }, "L'utilisateur devra reconfigurer son application d'authentification à la prochaine connexion.")
                          ], -1)),
                          _createElementVNode("button", {
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (reset2FA(selectedUser.value))),
                            disabled: resetting2FAId.value === selectedUser.value.id,
                            class: "inline-flex items-center gap-1.5 px-3 py-2 bg-red-50 text-red-700 border border-red-200 rounded-lg text-xs font-medium hover:bg-red-100 transition-colors disabled:opacity-50"
                          }, [
                            _createVNode(_unref(ShieldOff), { class: "w-3.5 h-3.5" }),
                            _createTextVNode(" " + _toDisplayString(resetting2FAId.value === selectedUser.value.id ? 'En cours…' : 'Réinitialiser'), 1)
                          ], 8, _hoisted_57)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode(UserFormModal, {
          "is-open": showModal.value,
          "user-id": editingUserId.value,
          onClose: closeModal,
          onSuccess: handleModalSuccess
        }, null, 8, ["is-open", "user-id"])
      ])
    ]),
    _: 1
  }))
}
}

})